<template>
  <div class="flex w-full flex-col gap-6 p-6" v-if="pageEnabled">
    <h3 class="text-3xl font-bold">Long & Short</h3>
    <div class="flex w-full items-center justify-between">
      <nav class="flex items-center">
        <button
          v-for="tab in tabs"
          class="whitespace-nowrap border-b-2 py-2 px-6 text-sm"
          :key="tab.value"
          :class="
            activeTab.value === tab.value ? ' border-ontick-blue-600' : 'dark:border-ontick-carbon-500 border-gray-50'
          "
          @click="activeTab = tab"
        >
          {{ tab.label }}
        </button>
      </nav>
      <div class="flex h-[42px] w-full items-center justify-end gap-2">
        <button
          content="Atualizar"
          v-tippy="{ arrow: true, theme: 'green' }"
          class="btn text-ontick-blue-600"
          @click="getOrders(getSelectedAccount.account_id, activeTab.value)"
        >
          <i v-html="$icons.refresh" :class="{ 'animate-spin': loadingAnimation }"></i>
        </button>
        <router-link :to="{ name: 'Pré-autorização Long & Short' }" class="h-full">
          <button
            content="Pré-autorização"
            v-tippy="{ arrow: true, theme: 'green' }"
            class="btn text-ontick-blue-600 h-full"
          >
            <i v-html="$icons.clipboard"></i>
          </button>
        </router-link>
        <!-- <button
          :content="`Alternar formato do resultado para ${
            resultFormat === 'fin' ? 'percentual' : 'financeiro'
          }`"
          v-tippy="{ arrow: true, theme: 'green' }"
          @click="toggleResultFormat"
          class="btn text-ontick-blue-600"
        >
          <i v-html="$icons.dollar" v-if="resultFormat === 'fin'"></i>
          <i v-html="$icons.percent" v-else></i>
        </button> -->
        <button @click="filterAeroIsActive = true" class="btn">
          <i v-html="$icons.filter"></i>
          <span> Filtros </span>
        </button>
        <div class="relative">
          <VueCtkDateTimePicker
            id="dashboard-datepicker"
            class="dashboard-datepicker w-full rounded-md shadow sm:w-56"
            v-model="selectedDate"
            label="Selecione o periodo"
            no-shortcuts
            locale="pt-BR"
            format="YYYY-MM-DDTHH:mm:ss.SSS[Z]"
            formatted="D MMM YYYY"
            :range="true"
            :dark="getUiTheme === 'DARK' ? true : false"
            :only-date="true"
            :noClearButton="true"
            :no-button-now="true"
            :max-date="moment().toISOString()"
            :disabled-weekly="[0, 6]"
            :no-value-to-custom-elem="true"
            @validate="getOrders(getSelectedAccount.account_id, activeTab.value)"
            @input="log"
          >
          </VueCtkDateTimePicker>
          <span
            class="dark:bg-ontick-steel-500 xs:block absolute inset-y-2.5 right-2 hidden bg-gray-50 pl-2"
            v-html="$icons.calendar"
          />
        </div>

        <router-link
          :to="{ name: 'Criar ordem Long & Short' }"
          class="bg-ontick-blue-600 dark:bg-ontick-blue-900 flex hidden h-full items-center justify-center gap-2 rounded-md px-4 shadow filter transition-all hover:brightness-110"
        >
          <div>
            <i v-html="$icons.plus"></i>
          </div>
          <span class="text-sm font-semibold"> Adicionar ordem </span>
        </router-link>
      </div>
    </div>
    <div class="w-full">
      <transition name="fade" mode="out-in">
        <div class="flex w-full items-center justify-center py-16" v-if="isLoading">
          <i v-html="$icons.loading" class="text-ontick-blue-600"></i>
          <span class="sr-only">Carregando</span>
        </div>
        <!-- <div
          v-else-if="!selectedOrders.length"
          class="flex w-full items-center justify-center py-16"
        >
          <h3 class="text-2xl font-bold">Sem ordens disponíveis.</h3>
        </div> -->
        <new-orders-table-component v-else :data="selectedOrders" />
        <!-- <orders-list-table-component
          :orders="selectedOrders"
          :section="activeTab.value"
          :resultFormat="resultFormat"
          v-else
        /> -->
      </transition>
    </div>
    <ontick-aero-component :active="filterAeroIsActive" @close="filterAeroIsActive = false">
      <filters-component :active="filterAeroIsActive" v-show="filterAeroIsActive" @close="filterAeroIsActive = false" />
    </ontick-aero-component>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ordersListTableComponent from "../components/orders-list/orders-list-table.component.vue";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import event_bus from "../../../shared/utils/event_bus";
import OntickAeroComponent from "../../../shared/components/basic/ontick-aero.component.vue";
import FiltersComponent from "../components/filters.component.vue";
import { v4 as uuidv4 } from "uuid";
import { getData } from "../store/getters";
import NewOrdersTableComponent from "../components/orders-list/new-orders-table/new-orders-table.component.vue";

export default {
  components: {
    ordersListTableComponent,
    VueCtkDateTimePicker,
    OntickAeroComponent,
    FiltersComponent,
    NewOrdersTableComponent,
  },

  data() {
    return {
      filterAeroIsActive: false,
      resultFormat: "fin", // fin, percent
      isLoading: true,
      loadingAnimation: false,
      tabs: [
        {
          label: "Minhas operações",
          value: "PRIVATE",
        },
        // {
        //   label: "Oportunidades",
        //   value: "PUBLIC",
        // },
        // {
        //   label: "Vínculadas",
        //   value: "BINDING_ONLY",
        // },
      ],
      activeTab: {
        label: "Privadas",
        value: "PRIVATE",
      },
      selectedDate: "",
      orders: {
        PRIVATE: [],
        PUBLIC: [],
        BINDING_ONLY: [],
      },
      interval: null,
      customShortcuts: [
        { key: "thisDay", label: "Hoje", value: "day" },
        { key: "thisWeek", label: "Essa semana", value: "isoWeek" },
        { key: "lastWeek", label: "Semana anterior", value: "-isoWeek" },
        { key: "last7Days", label: "Últimos 7 dias", value: 7 },
        { key: "last30Days", label: "Últimos 30 dias", value: 30 },
        { key: "thisMonth", label: "Esse mês", value: "month" },
        { key: "lastMonth", label: "Mês anterior", value: "-month" },
        { key: "thisYear", label: "Esse ano", value: "year" },
        { key: "lastYear", label: "Ano anterior", value: "-year" },
        {
          key: "last365Days",
          label: "Últimos 365 dias",
          value: () => {
            return {
              start: this.moment().subtract(365, "days"),
              end: this.moment(),
            };
          },
          status: "Entrando",
          result: 235,
          alg_ord_id: Math.floor(Math.random() * 1000),
        },
        {
          running: false,
          name: `L&S ${Math.floor(Math.random() * 10000)}`,
          symbols: {
            symbol1: {
              operation: "BUY",
              total_volume: 10000,
              current_volume: 0,
              symbol_name: "PETR4",
              direction: null,
            },
            symbol2: {
              operation: "SELL",
              total_volume: 10000,
              current_volume: 0,
              symbol_name: "VALE3",
              direction: null,
            },
          },
          status: "Encerrada",
          result: -235,
          alg_ord_id: Math.floor(Math.random() * 1000),
        },
        {
          running: true,
          name: `L&S ${Math.floor(Math.random() * 10000)}`,
          symbols: {
            symbol1: {
              operation: "BUY",
              total_volume: 10000,
              current_volume: 1234,
              symbol_name: "PETR4",
              direction: "-",
            },
            symbol2: {
              operation: "SELL",
              total_volume: 10000,
              current_volume: 4321,
              symbol_name: "VALE3",
              direction: "-",
            },
          },
          status: "Executando SL",
          result: 235,
          alg_ord_id: Math.floor(Math.random() * 1000),
        },
      ],
      contextUuid: uuidv4(),
      connectionStatus: {
        awaitingConnection: false,
        retries: 0,
        error: false,
      },
    };
  },

  computed: {
    ...mapGetters({
      getSelectedAccount: "accountTypes/getSelectedAccount",
      getUiTheme: "config/getUiTheme",
      getActiveFilters: "longShort/filters/getActiveFilters",
      getWebsocketIsConnected: "config/getWebsocketIsConnected",
      marketdata: "marketdata/getMarketdata",
      getConfigs: "config/getConfigs",
    }),
    pageEnabled() {
      if (!this.getConfigs.side_menus) return false;
      return this.getConfigs.side_menus.map((item) => item.menu_name).includes("Long & Short");
    },
    selectedOrders() {
      return this.orders[this.activeTab.value];
    },
    selectedAccount() {
      return Object.assign({}, this.getSelectedAccount);
    },
    topics() {
      let symbols = [];
      this.orders[this.activeTab.value].forEach((order) => {
        order.orders.forEach((trail) => {
          symbols.push(trail.trail_order_symbol);
        });
      });
      return Array(...new Set(symbols)).map((symbol) => {
        return this.formatTopic(symbol);
      });
    },
  },

  methods: {
    ...mapActions({ clearData: "longShort/clearData" }),
    toggleAnimation() {
      this.loadingAnimation = true;
      setTimeout(() => {
        this.loadingAnimation = false;
      }, 1000);
    },
    formatSymbol(topic) {
      return topic.split(".")[1];
    },
    formatTopic(symbol) {
      return `MD.${symbol}.L1`;
    },
    consume() {
      if (this.connectionStatus.retries > 5) {
        this.connectionStatus.error = true;
        console.error("[L&S] Erro ao conectar ao websocket.");
        return;
      }
      if (!this.getWebsocketIsConnected) {
        if (this.isSharedWorker) {
          this.worker.sendMessage({ type: "CHECK_CONNECTION" });
        }
        this.connectionStatus.retries++;
        this.connectionStatus.awaitingConnection = true;
        setTimeout(() => {
          this.consume();
        }, 2000);
        return;
      }
      this.connectionStatus.awaitingConnection = false;
      this.connectionStatus.error = false;
      this.worker.sendMessage({
        type: "CONSUME",
        data: {
          uuid: this.contextUuid,
          topics: this.topics,
          type: "Long & Short",
        },
      });
    },
    stopConsuming() {
      this.worker.sendMessage({
        type: "STOP_CONSUMING",
        data: this.contextUuid,
      });
    },
    toggleResultFormat() {
      if (this.resultFormat === "fin") {
        this.resultFormat = "percent";
      } else {
        this.resultFormat = "fin";
      }
    },
    log(event) {
      // console.log(event);
    },
    getOrders(account_id, visibility, status, start_datetime, end_datetime) {
      this.toggleAnimation();
      return new Promise((resolve, reject) => {
        this.isLoading = true;
        this.$api
          .get(this.$endpoint.LIST_ALGO_ORDERS(account_id), {
            params: {
              visibility,
              status: ["NEW", "ACTIVE"],
              start_datetime,
              end_datetime,
            },
          })
          .then((res) => {
            // console.log(res);
            this.orders[this.activeTab.value] = res.data;
            resolve(res.data);
          })
          .catch((err) => {
            console.error(err);
            reject(err);
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
    async getData(visibility) {
      this.isLoading = true;
      const account_id = await this.selectedAccount.account_id;
      if (account_id && !this.orders[visibility]?.length) {
        this.getOrders(account_id, visibility, undefined, this.selectedDate.start, this.selectedDate.end)
          .then((res) => {
            if (!res.length) {
              this.orders[visibility].no_orders = true;
            } else {
              this.orders[visibility] = res.map((order) => {
                let first_trail;

                order.orders.forEach((trail) => {
                  if (!first_trail) {
                    first_trail = trail;
                  } else if (trail.trail_order_id < first_trail.trail_order_id) {
                    first_trail = trail;
                  }
                });

                let symbols = Array(
                  ...new Set(
                    order.orders.map((trail) => {
                      return trail.trail_order_symbol;
                    })
                  )
                );

                return {
                  ...order,
                  info: {
                    ...order.info,
                    symbol_1: first_trail.trail_order_symbol,
                    symbol_2: symbols.find((symbol) => symbol !== first_trail.trail_order_symbol),
                  },
                };
              });
              this.orders[visibility].no_orders = false;
            }
          })
          .finally(() => {
            clearInterval(this.interval);
            this.isLoading = false;
          });
      } else {
        // console.log("no id");
        if (!this.interval) {
          this.interval = setInterval(() => {
            this.getData(visibility);
          }, 1000);
        }
      }
    },
    updateMarketdata(symbol, last_price) {
      this.orders[this.activeTab.value].forEach((order) => {
        if (order.info.symbol_1 === symbol) {
          order.info.symbol_1_last = last_price;
          // console.log(order.info.symbol_1_last);
        } else if (order.info.symbol_2 === symbol) {
          order.info.symbol_2_last = last_price;
          // console.log(order.info.symbol_2_last);
        }
      });
    },
  },

  watch: {
    topics: {
      // immediate: true,
      handler(val) {
        if (val.length) {
          this.consume();
        }
      },
    },
    marketdata: {
      deep: true,
      handler(val) {
        this.$nextTick(() => {
          this.topics.forEach((topic) => {
            const symbol = this.formatSymbol(topic);
            this.updateMarketdata(symbol, val[symbol]);
          });
        });
      },
    },
    activeTab: {
      deep: true,
      handler(val) {
        this.isLoading = true;
        this.getOrders(this.getSelectedAccount.account_id, val.value)
          .then((res) => {
            this.orders[val.value] = res;
          })
          .finally(() => {
            clearInterval(this.interval);
            this.isLoading = false;
          });
      },
    },
    selectedAccount: {
      deep: true,
      immediate: true,
      handler(val) {
        // console.log(val);
      },
    },
    getActiveFilters: {
      handler(val) {
        this.isLoading = true;

        this.getOrders(this.getSelectedAccount.account_id, this.activeTab.value, val)
          .then((res) => {
            this.orders[this.activeTab.value] = res;
          })
          .finally(() => {
            this.isLoading = false;
          });
      },
    },
    selectedDate: {
      deep: true,
      handler({ start, end }) {
        if (!end) {
          end = this.moment(start).endOf("day").toISOString();
        }
        this.isLoading = true;

        this.getOrders(this.getSelectedAccount.account_id, this.activeTab.value, this.getActiveFilters, start, end)
          .then((res) => {
            this.orders[this.activeTab.value] = res;
          })
          .finally(() => {
            this.isLoading = false;
          });
      },
    },
  },

  mounted() {
    this.clearData();
    const getOrders = () => {
      this.getOrders(this.getSelectedAccount.account_id, this.activeTab.value)
        .then((res) => {
          this.orders[this.activeTab.value] = res;
        })
        .finally(() => {
          clearInterval(this.interval);
          this.isLoading = false;
        });
    };
    event_bus.$on("RELOAD_ALGO_ORDERS", () => {
      getOrders();
    });
    event_bus.$on("CHANGE_ACCOUNT", () => {
      getOrders();
    });
    event_bus.$on("GO_TO_PUBLIC_ALGO_ORDERS", () => {
      this.activeTab = this.tabs[0];
      getOrders();
    });
    this.getData(this.activeTab.value);
  },

  beforeDestroy() {
    this.stopConsuming();
  },
};
</script>

<style lang="scss" scoped>
.fade {
  &-enter,
  &-leave-to {
    @apply scale-125 opacity-0;
  }
  &-enter-active,
  &-leave-active {
    @apply transition-all duration-300 ease-in-out;
  }
}
.btn {
  @apply border-ontick-steel-300 bg-ontick-steel-100 dark:bg-ontick-graphite-500 flex h-full min-w-[42px] items-center justify-center gap-2 rounded-md border-2 px-2 text-sm shadow filter transition-all hover:brightness-110 dark:border-0;
}
</style>
